<template>
  <!--
    flex (not block) so slot children are spaced via gap-y instead of space-y.
    Unlike block flow, flex does not collapse adjacent margins, so a child with a
    large own margin (e.g. a BorderedLayout's my-8) may need mt-0!/my-0! to neutralize it.
  -->
  <form
    class="flex flex-col gap-y-1"
    novalidate
    @submit.prevent="$emit('submit')"
  >
    <slot />
  </form>
</template>

<script setup lang="ts">
defineEmits(['submit'])
</script>
